import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FooterService {

  private lastUpdatedDateSubject = new BehaviorSubject<Date | null>(null);
  lastUpdatedDate$: Observable<Date | null> = this.lastUpdatedDateSubject.asObservable();

  setLastUpdatedDate(date: Date | string | null): void {
    if (!date) {
      this.lastUpdatedDateSubject.next(null);
      return;
    }
    const parsed = date instanceof Date ? date : new Date(date);
    this.lastUpdatedDateSubject.next(isNaN(parsed.getTime()) ? null : parsed);
  }

  clear(): void {
    this.lastUpdatedDateSubject.next(null);
  }
}
